export const hasInvalidAnswers = (
  choices: IChoiceItemProps[],
  has_multiple_correct_answers: boolean
) =>
  !has_multiple_correct_answers &&
  choices.filter((choice) => choice.is_correct_choice).length > 1;

export const hasInvalidChoices = (choices: IChoiceItemProps[]) =>
  choices.filter((choice) => choice.is_correct_choice).length < 1;
